import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import { githubLink, linkedInLink } from "../constants";
import { Button } from "@mui/material";

function Main(theme: any) {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
        </div>
        <div className="content">
         
          <h1>Joseph Skinner</h1>
          <p style={{marginBottom: 20}}
          >
            Software Engineer</p>
          
          <div className="social_icons">
            <a href={githubLink} target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href={linkedInLink} target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <div>
            <Button
                  target="_blank"
                  rel="noopener noreferrer"
                  component="a"
                  download="Joseph_Skinner_Resume.pdf"
                  href="/Resume_Joseph_Skinner.pdf"
                  variant="contained"
                  sx={{
                    '&:focus': { outline: 'none' },
                    '&:hover' : {backgroundColor : theme.theme === 'dark' ? '#ffffff' : '#ffffff'},
                    backgroundColor: theme.theme ==='dark'? '#5000ca' : '#ffffff',
                  }}
                >
                  Download Resume
                </Button>
            </div>
          
          </div>

          <div className="mobile_social_icons">
            <a href={githubLink} target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href={linkedInLink} target="_blank" rel="noreferrer"><LinkedInIcon/></a>
            <Button 
                  target="_blank"
                  rel="noopener noreferrer"
                  component="a"
                  download="Joseph_Skinner_Resume.pdf"
                  href="/Resume_Joseph_Skinner.pdf"
                  variant="contained"
                  sx={{
                    '&:focus': { outline: 'none' },
                    backgroundColor: theme.theme ==='dark'? '#5000ca' : '#ffffff',
                  }}
                >
                  Download Resume
                </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;